<template>
    <div class="outer">

        <el-dialog width="60%" :close-on-click-modal="false" :title="adialogTitle" :visible="avisible"
            @close="onCloseAdd">
            <el-card style="margin-bottom: 30px;">
                <div slot="header">
                    <span>供应商信息</span>
                </div>
                <el-form ref="formRef" :model="form" :rules="formRules" label-width="100px">
                    <el-row :gutter="100">
                        <el-col :span="12">
                            <el-form-item label="供应商名称" required prop="supplierName">
                                <el-input v-model="form.supplierName" placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="联系人名称" required prop="linkMan">
                                <el-input v-model="form.linkMan" placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="100">
                        <el-col :span="12">
                            <el-form-item label="联系人电话" required prop="phone">
                                <el-input v-model="form.phone" placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <div class="flex-center">
                                <el-form-item label="所属省市" required prop="province">
                                    <el-select v-model="form.province" @change="onFormProvinceChange" placeholder="请选择">
                                        <el-option v-for="item in provinces" :label="item.provinceName"
                                            :value="item.provinceCode" :key="item.provinceCode">
                                            {{ item.provinceName }}
                                        </el-option>
                                    </el-select>
                                </el-form-item>

                                <el-form-item required prop="city" label-width="10px">
                                    <el-select v-model="form.city" placeholder="请选择">
                                        <el-option v-for="item in formCitys" :label="item.cityName"
                                            :value="item.cityCode" :key="item.cityCode">
                                            {{ item.cityName }}
                                        </el-option>
                                    </el-select>
                                </el-form-item>

                            </div>

                        </el-col>
                    </el-row>
                    <el-row :gutter="100">
                        <el-col :span="12">
                            <el-form-item label="合作度" prop="cooperate">
                                <el-select v-model="form.cooperate" placeholder="请选择" style="width: 100%">
                                    <el-option v-for="item in cooperateSelects" :key="item.value" :value="item.value"
                                        :label="item.label">
                                        {{ item.label }}
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="信誉度" prop="credit">
                                <el-select v-model="form.credit" placeholder="请选择" style="width: 100%">
                                    <el-option v-for="item in creditSelect" :key="item.value" :value="item.value"
                                        :label="item.label">
                                        {{ item.label }}
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>

                    </el-row>
                    <el-row :gutter="100">
                        <el-col :span="12">
                            <el-form-item label="联系地址" required prop="address">
                                <el-input type="textarea" :rows="4" v-model="form.address" placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="备注"> 
                                <el-input type="textarea" :rows="4" v-model="form.remarks" placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-card>

            <el-card>
                <div class="flex-space-between" slot="header">
                    <span>供应商银行账户信息</span>
                    <el-button type="primary" @click="openbankDialog('add')">添加账户</el-button>
                </div>

                <el-radio-group style="width: 100%;" v-model="isMainIndex">
                    <el-table border :data="form.tbSupplierBankList">
                        <el-table-column align="center" label="设为首选">
                            <template slot-scope="scope">
                                <el-radio :label="scope.$index">&nbsp;</el-radio>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="户名" prop="bankUserName">
                        </el-table-column>
                        <el-table-column align="center" label="开户行" prop="openBank">
                        </el-table-column>
                        <el-table-column align="center" label="银行账号" prop="bankAccount">
                        </el-table-column>
                        <el-table-column align="center" label="操作" prop="operate">
                            <template slot-scope="scope">
                                <el-button type="text" icon="el-icon-edit"
                                    @click="openbankDialog('edit', scope.row, scope.$index)">修改</el-button>
                                <el-button type="text" style="color: #F56C6C" icon="el-icon-delete"
                                    @click="delAccount(scope.$index, scope.row.id)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-radio-group>
            </el-card>

            <span slot="footer" class="dialog-footer">
                <el-button @click="avisible = false">取 消</el-button>
                <el-button type="primary" :loading="btnLoading" @click="addSubmit">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog width="55%" :close-on-click-modal="false" :title="bankdialogTitle" :visible="addBankVisible"
            @close="onCloseAccountDialog">
            <el-card style="margin-bottom: 30px;">
                <el-form ref="bankformRef" :model="accountForm" :rules="accountRules" label-width="100px">
                    <el-row :gutter="100">
                        <el-col :span="11">
                            <el-form-item label="户名" required prop="bankUserName">
                                <el-input v-model="accountForm.bankUserName" placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="11">
                            <el-form-item label="银行账号" required prop="bankAccount">
                                <el-input v-model="accountForm.bankAccount" placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="100">
                        <el-col :span="11">
                            <el-form-item label="开户行" required prop="openBank">
                                <el-input v-model="accountForm.openBank" placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-card>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addBankVisible = false">取 消</el-button>
                <el-button type="primary" :disabled="submitSupplierDisable" @click="addAccount">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog width="50%" title="银行账户信息" :visible="bankInfoVisible" @close="bankInfoVisible = false">
            <el-card>
                <el-table border :key="bankInfoKey" class="detailTable" :data="accountInfo">
                    <el-table-column align="center" label="是否为首选">
                        <template slot-scope="scope">
                            <el-checkbox :checked="scope.row.isMain === 1" disabled></el-checkbox>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="户名" prop="bankUserName">
                    </el-table-column>
                    <el-table-column align="center" label="开户行" prop="openBank">
                    </el-table-column>
                    <el-table-column align="center" label="银行账号" prop="bankAccount">
                    </el-table-column>
                </el-table>
            </el-card>
        </el-dialog>

        <div class="topSearch">
            <el-form class="queryRow" inline>
                <el-form-item label="所属省份" class="queryCol">
                    <el-select v-model="queryForm.provinceCode" clearable @change="onProvinceChange">
                        <el-option v-for="item in provinces" :label="item.provinceName" :value="item.provinceCode"
                            :key="item.provinceCode">
                            {{ item.provinceName }}
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属城市" class="queryCol">
                    <el-select v-model="queryForm.cityCode" clearable @change="onCityChange">
                        <el-option v-for="item in queryCitys" :label="item.cityName" :value="item.cityCode"
                            :key="item.cityCode">
                            {{ item.cityName }}
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="供应商名称" class="queryCol">
                    <el-input placeholder="请输入" clearable @clear="onSearch" v-model="queryForm.supplierName"></el-input>
                </el-form-item>
                <el-form-item class="queryCol">
                    <el-button type="primary" icon="el-icon-search" @click="onSearch">
                        搜索
                    </el-button>
                </el-form-item>
            </el-form>

            <el-button type="primary" icon="el-icon-plus" @click="openAdialog('add')">
                新增供应商
            </el-button>
        </div>

        <el-table border v-loading="loading" class="table" :data="tableData" :row-style="{ height: '58px' }" fit style="margin-bottom: 20px;
        width: 100%;height: 68vh;overflow: auto;">
            <template slot="empty">
                <el-empty :image-size="150"></el-empty>
            </template>
            <el-table-column align="center" label="供应商名称" prop="supplierName">
            </el-table-column>
            <el-table-column align="center" label="所属省份" width="100px" prop="provinceName">
            </el-table-column>
            <el-table-column align="center" label="所属城市" width="100px" prop="cityName">
            </el-table-column>
            <el-table-column align="center" label="联系人" width="100" prop="linkMan">
            </el-table-column>
            <el-table-column align="center" label="联系电话" width="120" prop="phone">
            </el-table-column>
            <el-table-column align="center" label="联系地址" prop="address">
            </el-table-column>
            <el-table-column align="center" label="合作度" width="80px" prop="cooperate">
                <template slot-scope="scope">
                    <el-tag :type="cooperateType(scope.row.cooperate)">{{ cooperateText(scope.row.cooperate)
                    }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column align="center" label="信誉度" width="80px" prop="credit">
                <template slot-scope="scope">
                    <el-tag :type="creditType(scope.row.credit)">{{ creditText(scope.row.credit) }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column align="center" label="备注" prop="remarks">
            </el-table-column>
            <el-table-column align="center" label="操作" prop="operate">
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-edit" @click="openAdialog('edit', scope.row)">修改</el-button>
                    <el-button type="text" icon="el-icon-s-finance" @click="openBankInfo(scope.row)">账户信息</el-button>
                    <!-- <el-button type="text" icon="el-icon-delete" style="color: #F56C6C"
                        @click="delSupplier(scope.row)">删除</el-button> -->
                </template>
            </el-table-column>
        </el-table>

        <div class="pageination">
            <el-pagination @size-change="onSizeChange" @current-change="onCurrentChange" :total="total"
                :page-size="pageSize" :page-sizes="[10, 20, 30, 40, 50, 100]" :current-page="page" background
                layout="sizes, prev, pager, next, jumper, ->, total">
            </el-pagination>
        </div>

    </div>
</template>
<script>
import { postProvinces, postCitys } from "@/api/SlmsData/Supplier";
import { getSupplierList, insertSupplier, updateSupplier, deleteSupplier, deleteBank, addBank } from '@/api/goods/goodsBusiness.js';
export default {
    data() {
        return {
            btnLoading: false,
            submitSupplierDisable: false,
            loading: false, // 加载中
            bankdialogType: '', // 银行弹窗类型
            adialogType: '', // 判断弹窗是新增还是修改
            adialogTitle: '', // 判断是新增的标题,修改标题
            bankdialogTitle: '', // 银行信息弹窗标题
            tableData: [],
            isMainIndex: 0,
            form: {
                category: '', // 采购分类
                supplierName: '',
                linkMan: '',
                phone: '',
                province: '360000',
                city: '360100', // 城市
                cooperate: '',
                credit: '',
                address: '',
                remarks: '', //备注
                tbSupplierBankList: []
            },
            accountForm: {
                bankUserName: '', // 户名
                openBank: '', // 开户行
                bankAccount: '', // 银行账号
            },//银行账户对象
            accountRules: {
                bankUserName: [
                    { required: true, message: '请输入户名' }
                ],
                openBank: [
                    { required: true, message: '请输入开户行' }
                ],
                bankAccount: [
                    { required: true, message: '请输入银行账号' }
                ]
            },
            formRules: {
                supplierName: [
                    { required: true, message: '请输入供应商名称' }
                ],
                linkMan: [
                    { required: true, message: '请输入联系人' }
                ],
                phone: [
                    { required: true, message: '请输入手机号码' }
                ],
                province: [
                    { required: true, message: '请选择省份' }
                ],
                city: [
                    { required: true, message: '请选择城市' }
                ],
                address: [
                    { required: true, message: '请输入联系地址' }
                ],
            },
            accountInfo: [
                { accountName: '刘囖', openBank: '开户行', account: '1485562' }
            ],
            cooperateSelects: [
                { label: '未知', value: '0' },
                { label: '经常', value: '1' },
                { label: '偶然', value: '2' }
            ],
            creditSelect: [
                { label: '未知', value: '0' },
                { label: '低', value: '1' },
                { label: '中', value: '2' },
                { label: '高', value: '3' },
            ],
            avisible: false, // 添加和修改显隐
            addBankVisible: false, // 添加银行信息弹窗显影
            bankInfoVisible: false, // 详情显隐
            queryForm: {
                provinceCode: '', // 省份
                cityCode: '' // 城市
            }, //查询表单
            provinces: [], // 省份列表
            queryCitys: [], // 城市列表
            formCitys: [], // 表单城市列表
            total: 0, // 总条目数
            pageSize: 10,
            page: 1,
            editBankIndex: '', // 当前修改银行信息的index
            bankInfoKey: 0,
            category: '', // 采购分类
        }
    },
    async created() {
        let roleId = sessionStorage.getItem('userRoleId');
        if (roleId == 28) {
            this.category = "商务";
        } else if (roleId == 1 || roleId == 27 || roleId == 48 || roleId == 31) {
            // roleId
            // 1  admin  48 || 31  行政&行政主管  27 财务
            this.category = "行政";
        }
        await this.getSupplierList();
        this.getProvinces();
        this.getFormCitys(this.form.province);

    },
    computed: {
    },
    methods: {
        // 当每页条数变化
        onSizeChange(e) {
            this.page = 1;
            this.pageSize = e;
            this.getSupplierList();
        },
        // 搜索
        onSearch() {
            this.page = 1;
            this.getSupplierList();
        },
        // 当页码发生变化时
        onCurrentChange(e) {
            this.page = e;
            this.getSupplierList();
        },
        // 打开银行卡详情页面
        openbankDialog(type, row, index) {
            if (type === 'add') {
                this.bankdialogType = 'add';
                this.bankdialogTitle = '添加银行账户';
            } else if (type === 'edit') {
                this.editBankIndex = index;
                this.bankdialogType = 'edit';
                this.bankdialogTitle = '修改银行账户';
                this.accountForm = { ...row };
            }
            this.addBankVisible = true;
        },
        // 判断打开的是新增还是修改的弹窗
        openAdialog(type, row) {
            if (type === 'add') {
                this.adialogType = 'add';
                this.adialogTitle = '新增供应商';
            } else if (type === 'edit') {
                this.adialogType = 'edit';
                this.adialogTitle = '修改供应商';
                this.form = { ...row };
                this.getFormCitys(row.province);
                let index = this.form.tbSupplierBankList.findIndex(item => {
                    return item.isMain == 1
                })
                this.isMainIndex = (index === -1) ? 0 : index
            }

            this.avisible = true;
        },
        // 合作度状态码对应文字
        cooperateText(value) {
            switch (value) {
                case '0':
                    return '未知'
                case '1':
                    return '经常'
                case '2':
                    return '偶然'
            }
        },
        // 合作度状态码对应类型
        cooperateType(value) {
            switch (value) {
                case '0':
                    return 'info'
                case '1':
                    return 'success'
                case '2':
                    return ''
            }
        },
        // 信誉度状态码对应文字
        creditText(value) {
            switch (value) {
                case '0':
                    return '未知'
                case '1':
                    return '低'
                case '2':
                    return '中'
                case '3':
                    return '高'
            }
        },
        // 信誉度状态码对应类型
        creditType(value) {
            switch (value) {
                case '0':
                    return 'info'
                case '1':
                    return 'warning'
                case '2':
                    return ''
                case '3':
                    return 'success'
            }
        },
        // 获取供应商列表
        async getSupplierList() {
            this.loading = true;
            await getSupplierList({
                supplierName: this.queryForm.supplierName,
                provinceCode: this.queryForm.provinceCode,
                cityCode: this.queryForm.cityCode,
                category: this.category,
                page: this.page,
                limit: this.pageSize
            }).then((res) => {
                if (res.code === 200) {
                    this.tableData = res.data;
                    this.total = res.total;
                    this.loading = false
                }
            })
        },
        // 新增和修改省份改变
        onFormProvinceChange(provinceCode) {
            this.form.city = '';
            this.getFormCitys(provinceCode);
            this.$forceUpdate();
        },
        // 获取表单所选城市
        getFormCitys(provinceCode) {
            postCitys(provinceCode).then((res) => {
                this.formCitys = res;
            })
        },
        // 当筛选条件-省份改变
        onProvinceChange() {
            this.queryForm.cityCode = '';
            this.getCitys(this.queryForm.provinceCode);
            this.page = 1;
            this.getSupplierList();
        },
        // 当筛选条件-城市改变
        onCityChange() {
            this.page = 1;
            this.getSupplierList();
        },
        // 获取所有省份的列表
        getProvinces() {
            postProvinces().then((res) => {
                this.provinces = res;
            })
        },
        // 获取所选城市
        getCitys(provinceCode) {
            postCitys(provinceCode).then((res) => {
                this.queryCitys = res;
            })
        },
        // 删除该供应商
        delSupplier(row) {
            this.$confirm('确定删除该供应商', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteSupplier(row).then((res) => {
                    if (res.code === 200) {
                        this.getSupplierList();
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                    }
                })

            })
        },
        // 删除银行账户
        delAccount(i, id) {
            this.$confirm('确定删除该银行账户', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                // if(this.form.tbSupplierBankList.length <= 1){
                //     this.$message({
                //         type: 'warning',
                //         message: '至少需要一个银行账号',
                //     });
                //     return;
                // }
                if (i === this.isMainIndex) {
                    this.isMainIndex = 0;
                }
                
                this.form.tbSupplierBankList.splice(i, 1);

                if (this.adialogType === 'edit' && id) {
                    deleteBank({ id }).then(res => {
                        if (res.code === 200) {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                        }
                    })
                } else {
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                }
            })
        },
        // 添加或修改供应商
        addSubmit() {
            this.$refs['formRef'].validate((valid) => {
                if (valid) {
                    
                    // if(this.form.tbSupplierBankList.length <= 0 ){
                    //     this.$message({
                    //         type: 'warning',
                    //         message: '银行账户信息为空'
                    //     });
                    //     return;
                    // }
                    this.btnLoading = true;
                    if (this.form.tbSupplierBankList.length > 0) {
                        this.form.tbSupplierBankList.forEach(item => {
                            item.isMain = 0;
                        })
                        this.form.tbSupplierBankList[this.isMainIndex].isMain = 1;
                    }

                    if (this.adialogType === 'add') {
                        insertSupplier({ ...this.form, category: this.category }).then(res => {
                            this.btnLoading = false;
                            if (res.code === 200) {
                                this.page = 1;
                                this.getSupplierList();
                                this.avisible = false
                                this.$message({
                                    type: 'success',
                                    message: '添加供应商信息成功!'
                                });
                            }
                        })
                    } else if (this.adialogType === 'edit') {
                        updateSupplier(this.form).then(res => {
                            this.btnLoading = false;
                            if (res.code === 200) {
                                this.getSupplierList();
                                this.avisible = false
                                this.$message({
                                    type: 'success',
                                    message: '修改供应商信息成功!'
                                });
                            }
                        })
                    }

                }
            })
        },
        // 关闭弹窗
        onCloseAdd() {
            this.form = {};
            this.avisible = false;
            this.form.city = '';
            this.formCitys = [];
            this.isMainIndex = 0;
            this.form.tbSupplierBankList = [];
            this.$refs['formRef'].resetFields();
        },
        // 关闭添加银行账户弹窗
        onCloseAccountDialog() {
            this.addBankVisible = false;
            this.accountForm = {};
            this.$refs['bankformRef'].resetFields();
        },
        // 添加银行账户
        addAccount() {
            this.$refs['bankformRef'].validate((valid) => {
                if (valid) {

                    let bankForm = { ...this.accountForm }
                    if (this.bankdialogType === 'add') {

                        if (this.adialogType === 'edit') {
                            addBank({ ...bankForm, supplierCode: this.form.supplierCode }).then(res => {
                                if (res.code === 200) {
                                    this.form.tbSupplierBankList.push(bankForm);
                                    this.$message({
                                        type: 'success',
                                        message: '添加银行卡成功!'
                                    });
                                    this.addBankVisible = false;
                                    this.getSupplierList();
                                }
                            })
                        } else {
                            this.form.tbSupplierBankList.push(bankForm);
                            this.$message({
                                type: 'success',
                                message: '添加银行卡成功!'
                            });
                        }


                    } else if (this.bankdialogType === 'edit') {
                        this.form.tbSupplierBankList.splice(this.editBankIndex, 1, bankForm);
                        this.$message({
                            type: 'success',
                            message: '修改银行卡成功!'
                        });
                    }

                    this.addBankVisible = false;
                }
            })
        },
        // 打开银行信息
        openBankInfo(rowInfo) {
            this.accountInfo = rowInfo.tbSupplierBankList;
            // this.$forceUpdate();
            this.bankInfoKey++;
            this.bankInfoVisible = true;
        }
    },
}
</script>
<style lang="scss" scoped>
.outer {
    .pageination {
        display: flex;
        justify-content: flex-end;
        margin-top: 5px
    }

    .topSearch {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
    }

    .queryRow {
        overflow: hidden;
        display: flex;

        .queryName {
            width: 300px;
            margin-right: 10px;
        }

        .dataPicker {
            margin-right: 10px;
        }
    }

    .detailTable {
        ::v-deep .el-checkbox__input {
            &.is-checked {
                .el-checkbox__inner {
                    background-color: #409EFF;
                    border-color: #409EFF;
                }
            }
        }
    }

    .el-form-item {
        margin-right: 20px;
    }

    .table {

        ::v-deep .el-table__cell {
            >:empty::before {
                content: '--';
                color: gray;
            }
        }
    }
}
</style>
